import Vue from 'vue'
import VueRouter from 'vue-router'
import { getToken } from '@/utils/auth'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/',
    name: 'Layout',
    component: () => import('@/components/Layout/index.vue'),
    redirect: to => {
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
      return userInfo.role === 'super' ? '/sys-admin' : '/shops'
    },
    children: [
      {
        path: 'shops',
        name: 'Shops',
        component: () => import('@/views/shops/index.vue'),
        meta: { title: '门店管理', icon: 'el-icon-office-building' }
      },
      {
        path: 'prizes',
        name: 'Prizes',
        component: () => import('@/views/prizes/index.vue'),
        meta: { title: '奖品管理', icon: 'el-icon-gift' }
      },
      
      {
        path: 'codes',
        name: 'Codes',
        component: () => import('@/views/codes/index.vue'),
        meta: { title: '兑换码管理', icon: 'el-icon-key' }
      },
      {
        path: 'batch-records',
        name: 'BatchRecords',
        component: () => import('@/views/batch-records/index.vue'),
        meta: { title: '批次记录', icon: 'el-icon-document-copy' }
      },
      {
        path: 'ranking',
        name: 'Ranking',
        component: () => import('@/views/ranking/index.vue'),
        meta: { title: '门店排行榜', icon: 'el-icon-trophy' }
      },
      {
        path: 'records',
        name: 'Records',
        component: () => import('@/views/records/index.vue'),
        meta: { title: '中奖记录', icon: 'el-icon-s-order' }
      },
      {
        path: 'participants',
        name: 'Participants',
        component: () => import('@/views/participants/index.vue'),
        meta: { title: '参与人员记录', icon: 'el-icon-user' }
      },
      {
        path: 'blacklist',
        name: 'Blacklist',
        component: () => import('@/views/blacklist/index.vue'),
        meta: { title: '黑名单列表', icon: 'el-icon-user-solid' }
      },
      {
        path: 'settings',
        name: 'Settings',
        component: () => import('@/views/settings/index.vue'),
        meta: { title: '配置管理', icon: 'el-icon-setting' }
      },
      {
        path: 'sys-admin',
        name: 'SysAdmin',
        component: () => import('@/views/sys-admin/index.vue'),
        meta: { title: '总部管理', icon: 'el-icon-user', isSuperAdmin: true }
      },
      {
        path: 'limited-users',
        name: 'LimitedUsers',
        component: () => import('@/views/limited-users/index.vue'),
        meta: { title: '参与人员限制', icon: 'el-icon-user', isSubAdmin: true }
      },
      {
        path: 'reset-test-data',
        name: 'ResetTestData',
        component: () => import('@/views/reset-test-data/index.vue'),
        meta: { title: '清除测试数据', icon: 'el-icon-delete', isSubAdmin: true }
      }
    ]
  },
  {
    path: '*',
    redirect: '/login'
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: '/admin/',
  routes
})

router.beforeEach((to, from, next) => {
  const token = getToken()
  if (to.path === '/login') {
    if (token) {
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
      const redirectPath = userInfo.role === 'super' ? '/sys-admin' : '/shops'
      next(redirectPath)
    } else {
      next()
    }
  } else {
    if (token) {
      next()
    } else {
      next('/login')
    }
  }
})

export default router